import { createSelector } from '@reduxjs/toolkit';
import { Article } from '@wix/answers-api';

import { CategoryItemType } from '../api/getCategories';
import { TRootState } from '../reducers';
import { IArticleState, PresentedState } from '../reducers/types';

export const selectCategories = (state: TRootState): CategoryItemType[] | undefined => {
  return state.helpCenter.categories;
};

export const selectCategoryArticles = (state: TRootState): Article[] => {
  return state.helpCenter.categoryArticles;
};

export const selectNormalizedCategories = (state: TRootState): Record<number, CategoryItemType> => {
  return state.helpCenter.normalizedCategories;
};

export const selectCurrentCategory = (state: TRootState) => {
  return state.helpCenter.currentCategory;
};

export const selectArticle = (state: TRootState): Article | null => {
  return state.helpCenter.article.article;
};

export const selectArticleState = (state: TRootState): IArticleState => {
  return state.helpCenter.article;
};

export const selectCurrentPresentedState = (state: TRootState): PresentedState | undefined =>
  state.helpCenter.currentPresentedState;

export const selectPreviousPresentedState = (state: TRootState): PresentedState | undefined =>
  state.helpCenter.previousPresentedState;

export const selectSearchedText = (state: TRootState): string => state.helpCenter.searchedText;

export const selectCategoryPath = createSelector(
  [selectCurrentCategory, selectArticle, selectNormalizedCategories],
  (category, article, normalizedCategories) => {
    const categoryId = category?.id;
    const articleCategoryId = article?.categoryId;

    if (!categoryId && !articleCategoryId) {
      return [];
    }

    let currentCategory = articleCategoryId
      ? normalizedCategories[articleCategoryId]
      : normalizedCategories[categoryId!];
    const categoryPath = [currentCategory];

    while (currentCategory?.parentId) {
      currentCategory = normalizedCategories[currentCategory.parentId];
      categoryPath.unshift(currentCategory);
    }

    return categoryPath.filter((path) => Boolean(path));
  },
);

export const selectArticleHeadingVisible = (state: TRootState) =>
  state.helpCenter.article.articleHeadingVisible;

export const selectFullPageSidebarOpened = (state: TRootState) => state.helpCenter.fullPageSidebarOpened;

export const selectFullPageSidebarExtended = (state: TRootState) => state.helpCenter.fullPageSidebarExtended;
